<template lang="pug">

span.reveal-text(ref="container")
  span {{ text }}

</template>


<script>
import baffle from 'baffle'

export default {
  name: 'reveal-text',
  props: {
    characters: {
      default: '0123456789'
    },
    text: {
      default: '00'
    },
    reveal: {
      default: false
    },
    time: {
      default: 1000
    }
  },
  data () {
    return {
      b: null
    }
  },
  mounted: function () {

    this.b = baffle(this.$refs.container, {
      characters: this.characters,
      speed: 75
    })
    this.b.start()
    this.check()

  },
  methods: {
    check () {
      if (this.reveal) {
        this.show()
      } else {
        this.hide()
      }
    },
    show () {
      this.b.reveal(this.time)
    },
    hide () {
      this.b.start()
    }
  },
  watch: {
    reveal () {
      this.check()
    },
    text (val) {
      // console.log(444, val)
      this.b.text(currentText => JSON.stringify(val))
      this.check()
    }
  }
}
</script>


<style lang="sass" scoped>

.reveal-text


</style>





// WEBPACK FOOTER //
// RevealText.vue?43f5267e